/**
 * @generated SignedSource<<4ac53f606c72dcd2535a1a57e409d318>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type goalsQuery$variables = {
  goalId: string;
};
export type goalsQueryVariables = goalsQuery$variables;
export type goalsQuery$data = {
  readonly viewer: {
    readonly goal: {
      readonly childrenList: ReadonlyArray<{
        readonly entityId: string;
      } | null> | null;
      readonly " $fragmentSpreads": FragmentRefs<"GoalHeader_goal" | "GoalProfileTimelineTab_activities" | "GoalProfileKeyResultsTab_metricsList" | "GoalProfileInformationTab_information">;
    } | null;
  } | null;
};
export type goalsQueryResponse = goalsQuery$data;
export type goalsQuery = {
  variables: goalsQueryVariables;
  response: goalsQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "goalId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "goalId",
    "variableName": "goalId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "private",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v7 = {
  "alias": "amountType",
  "args": null,
  "kind": "ScalarField",
  "name": "computedAmountType",
  "storageKey": null
},
v8 = {
  "alias": "goalAmount",
  "args": null,
  "kind": "ScalarField",
  "name": "computedGoalAmount",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progressAmount",
  "storageKey": null
},
v10 = {
  "alias": "startingAmount",
  "args": null,
  "kind": "ScalarField",
  "name": "computedStartingAmount",
  "storageKey": null
},
v11 = {
  "alias": "type",
  "args": null,
  "kind": "ScalarField",
  "name": "computedType",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "computedProgressAmount",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v14 = [
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "avatarUrl",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "preferredName",
    "storageKey": null
  },
  (v3/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v16 = [
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "goalsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": "goal",
            "args": (v1/*: any*/),
            "concreteType": "Goal",
            "kind": "LinkedField",
            "name": "findGoal",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Goal",
                "kind": "LinkedField",
                "name": "childrenList",
                "plural": true,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GoalHeader_goal"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GoalProfileTimelineTab_activities"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GoalProfileKeyResultsTab_metricsList"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GoalProfileInformationTab_information"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "goalsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": "goal",
            "args": (v1/*: any*/),
            "concreteType": "Goal",
            "kind": "LinkedField",
            "name": "findGoal",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Goal",
                "kind": "LinkedField",
                "name": "childrenList",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/),
              (v2/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "priority",
                "storageKey": null
              },
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "includeChildren",
                    "value": false
                  }
                ],
                "concreteType": "goalActivitiesConnection",
                "kind": "LinkedField",
                "name": "activities",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "goalActivitiesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Activity",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sourceableType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "source",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "__typename",
                                "storageKey": null
                              },
                              {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isActivitySource"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v2/*: any*/),
                                  (v13/*: any*/),
                                  (v15/*: any*/)
                                ],
                                "type": "Goal",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v2/*: any*/),
                                  (v13/*: any*/),
                                  (v15/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "increase",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": "status",
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "updateStatus",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "comment",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Goal",
                                    "kind": "LinkedField",
                                    "name": "goal",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "goalAmount",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "amountType",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "type",
                                        "storageKey": null
                                      },
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "GoalUpdate",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v16/*: any*/),
                                "type": "Node",
                                "abstractKey": "__isNode"
                              }
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "activities(includeChildren:false)"
              },
              {
                "alias": "childGoals",
                "args": null,
                "concreteType": "Goal",
                "kind": "LinkedField",
                "name": "childrenList",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Goal",
                    "kind": "LinkedField",
                    "name": "childrenList",
                    "plural": true,
                    "selections": (v16/*: any*/),
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "state",
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "ownersList",
                "plural": true,
                "selections": (v14/*: any*/),
                "storageKey": null
              },
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dueDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isDepartmentGoal",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "companyGoal",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Tag",
                "kind": "LinkedField",
                "name": "tags",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "793d8f7fcee05a42f48c9c999655f0dd",
    "id": null,
    "metadata": {},
    "name": "goalsQuery",
    "operationKind": "query",
    "text": "query goalsQuery(\n  $goalId: String!\n) {\n  viewer {\n    goal: findGoal(goalId: $goalId) {\n      childrenList {\n        entityId\n        id\n      }\n      ...GoalHeader_goal\n      ...GoalProfileTimelineTab_activities\n      ...GoalProfileKeyResultsTab_metricsList\n      ...GoalProfileInformationTab_information\n      id\n    }\n    id\n  }\n}\n\nfragment Activity_activity on Activity {\n  entityId\n  createdAt\n  sourceableType\n  source {\n    __typename\n    __isActivitySource: __typename\n    ... on Goal {\n      ...GoalCreated_goal\n    }\n    ... on GoalUpdate {\n      ...GoalUpdate_update\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment GoalBadge_goal on Goal {\n  computedProgressAmount\n  entityId\n  id\n  state\n  status\n  type: computedType\n}\n\nfragment GoalCard_goal on Goal {\n  childrenList {\n    id\n  }\n  entityId\n  id\n  name\n  private\n  state\n  status\n  ...GoalProgress_goal\n  ...GoalBadge_goal\n}\n\nfragment GoalCreated_goal on Goal {\n  entityId\n  createdAt\n  creator {\n    name\n    avatarUrl\n    ...TimelineItem_user\n    id\n  }\n}\n\nfragment GoalHeader_goal on Goal {\n  id\n  entityId\n  name\n  private\n  priority\n  status\n  ...GoalProgress_goal\n}\n\nfragment GoalProfileInformationTab_information on Goal {\n  ownersList {\n    name\n    avatarUrl\n    preferredName\n    id\n  }\n  createdAt\n  dueDate\n  isDepartmentGoal\n  companyGoal\n  tags {\n    entityId\n    name\n    id\n  }\n}\n\nfragment GoalProfileKeyResultsTab_metricsList on Goal {\n  childGoals: childrenList {\n    ...GoalCard_goal\n    id\n  }\n}\n\nfragment GoalProfileTimelineTab_activities on Goal {\n  activities(includeChildren: false) {\n    edges {\n      node {\n        createdAt\n        ...Activity_activity\n        id\n      }\n    }\n  }\n}\n\nfragment GoalProgress_goal on Goal {\n  id\n  amountType: computedAmountType\n  goalAmount: computedGoalAmount\n  progressAmount\n  startingAmount: computedStartingAmount\n  type: computedType\n  computedProgressAmount\n}\n\nfragment GoalUpdate_update on GoalUpdate {\n  entityId\n  createdAt\n  creator {\n    name\n    avatarUrl\n    ...TimelineItem_user\n    id\n  }\n  increase\n  status: updateStatus\n  comment\n  goal {\n    entityId\n    goalAmount\n    amountType\n    type\n    id\n  }\n}\n\nfragment TimelineItem_user on User {\n  ...UserChip_user\n}\n\nfragment UserChip_user on User {\n  preferredName\n  name\n  avatarUrl\n}\n"
  }
};
})();

(node as any).hash = "4d316f5f90484b7518b55c9e2b864e82";

export default node;
